export default __webpack_public_path__ + "static/media/project_thumbnail_traplabs.9b2dcf99.png";